import "react-day-picker/dist/style.css";
import "./appointment.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import React, { useContext, useEffect, useState } from "react";
import {
  getAvailableDate,
  getDurations,
  getPlaces,
  getProfessionals,
} from "../../../services/scheduling";

import Button from "../../atoms/button/button";
import ConfirmedAppointment from "../../molecules/confirmed-appointment/confirmedAppointment";
import { DayPicker } from "react-day-picker";
import DropdownComponent from "../../atoms/dropdown-component/dropdownComponent";
import GlobalContext from "../../../contexts/globalContext";
import Loading from "../../atoms/loading/loading";
import Slider from "react-slick";
import Summary from "../../molecules/summary/summary";
import { es } from "date-fns/locale";
import { format } from "date-fns";
import iconFemale from "../../../assets/icons/icon-female.png";
import iconMale from "../../../assets/icons/icon-male.png";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import useDropdown from "./hooks/useDropdown";
import PelaseLogin from "./components/PelaseLogin";
import Error from "./components/Error";
import Dots from "./components/Dots";
import Footer from "./components/Footer";

type TransformedProfessional = {
  id: number;
  name: string;
  profession: string | null;
  sex: string | null;
};

const settings = {
  className: "o-appointment__slider",
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  vertical: true,
  verticalSwiping: true,
  rows: 1,
  appendDots: (dots) => Dots({dots}),
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        vertical: true,
        verticalSwiping: true,
      },
    },
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        vertical: false,
        verticalSwiping: false,
      },
    },
    {
      breakpoint: 570,
      settings: {
        slidesToShow: 1.04,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        vertical: false,
        verticalSwiping: false,
      },
    },
    {
      breakpoint: 440,
      settings: {
        slidesToShow: 1.04,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        vertical: false,
        verticalSwiping: false,
        appendDots: (dots) => Dots({dots}),
      },
    },
  ],
};

const Appointment = React.memo((props: any) => {
  const { window } = useBrowserMode();
  const [currentpagehours, setCurrentpagehours] = useState(0);
  const [selected, setSelected] = useState<Date | undefined>();
  const [selectedCard, setSelectedCard] = useState(undefined);
  const [nameProfessional, setNameProfessional] = useState([]);
  const [informationService, setInformationService] = useState<any>([]);
  const [dateTimeAvailability, setDateTimeAvailability] = useState<
    | Array<{
        date: string;
        availability: {
          options: Array<any>;
        };
      }>
    | undefined
  >([]);
  const [availableDates, setAvailableDates] = useState<Date[]>([]);
  const [loadingProfessionals, setLoadingProfessionals] = useState(false);
  const [hours, setHours] = useState<string[]>([]);
  const [appointmentDate, setAppointmentDate] = useState<[]>([]);
  const [hoursSelected, setHoursSelected] = useState<string[]>([]);
  const globalContext = useContext(GlobalContext);
  const [showConfirmedAppointment, setShowConfirmedAppointment] = useState(
    false
  );
  const [dayAvailablSelected, setDayAvailableSelected] = useState<
    | {
        date: string;
        availability: {
          options: any[];
        };
      }
    | undefined
  >(undefined);
  const [professionals, setProfessionals] = useState<TransformedProfessional[]>(
    []
  );
  const [itemsPerPageHours, setItemsPerPageHours] = useState(
    typeof window !== "undefined" && window.innerWidth <= 970 ? 4 : 6
  );

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownDurationOpen, setIsDropdownDurationOpen] = useState(false);

  const [durations, dispatchDurations] = useDropdown();
  const [places, dispatchPlaces] = useDropdown();

  const handleDropdownToggle = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };
  const handleDropdownDurationToggle = () => {
    setIsDropdownDurationOpen((prevState) => !prevState);
  };

  const handleSelectPlace = (placeId) => {
    dispatchPlaces({type: "SET_VALUE", payload: placeId});
    setSelectedCard(undefined);
    setSelected(undefined);
    setAvailableDates([]);
    setNameProfessional([]);
    setIsDropdownOpen(true);
  };

  const handleSelectDuration = (durationId) => {
    dispatchDurations({type: "SET_VALUE", payload: durationId});
    setInformationService({
      price: durations.options.find((item) => item.id === durationId).price,
      url: durations.options.find((item) => item.id === durationId).url,
    });
  };

  useEffect(() => {
    handleResize(); // Llamada inicial para establecer el valor correcto
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    const itemsPerPage =
      window.innerWidth <= 570 ? 2 : window.innerWidth <= 970 ? 4 : 6;
    setItemsPerPageHours(itemsPerPage);
  };

  const getProfessionalsList = async (service, place) => {
    try {
      const responseData = await getProfessionals(service, place, token);
      const data = transformProfessionalsData(responseData.data.professionals);
      setProfessionals(data);
      //  setloading(false); este era el que estaba
      // TODO: new one.
      setLoadingProfessionals(false);
      // TODO: end of new one
    } catch (error) {
      console.error("Error al obtener profesionales:", error);
    }
  };

  function transformProfessionalsData(
    professionalsData
  ): TransformedProfessional[] {
    return professionalsData.map((professional) => {
      const [name, profession, sex] = professional.maskName.split("_");
      return {
        id: professional.id,
        name: name.replace(/_/g, " "),
        profession: profession,
        sex,
      };
    });
  }

  const chooseprofessional = (e, name, month?) => {
    setNameProfessional(name);
    if (selectedCard !== e || month != undefined) {
      setSelected(undefined);
      setHoursSelected([]);
      setHours([]);
      setSelectedCard(e);
      let dateToSend;
      if (month) {
        const date = new Date(month);
        const year = date.getFullYear();
        const monthSelected = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        dateToSend = `${year}-${monthSelected}-${day}`;
      } else {
        dateToSend = new Date().toISOString().split("T")[0];
      }
      getAvailableDate(places.value, e, durations.value, dateToSend, token).then(
        // getAvailableDate(e, InformationService?.serviceIdTimify, dateToSend).then(
        (responseData) => {
          if (responseData) {
            const availableDatesList = extractAvailableDates(responseData.data);
            setDateTimeAvailability(responseData.data);
            setAvailableDates(availableDatesList);
          }
        }
      );
    }
  };

  const extractAvailableDates = (data) => {
    const availableDates: Date[] = [];
    data.forEach((dates) => {
      if (dates.availability.options.length > 0) {
        const dateParts = dates.date.split("-");
        if (dateParts.length === 3) {
          const year = parseInt(dateParts[0]);
          const month = parseInt(dateParts[1]) - 1;
          const day = parseInt(dateParts[2]);
          const formattedDate = new Date(year, month, day);
          availableDates.push(formattedDate);
        }
      }
    });
    return availableDates;
  };

  const hourselect = (e) => {
    setHoursSelected(e);
    const foundOptionQuote = dayAvailablSelected?.availability.options.find(
      (option) => option.time === e
    );
    setAppointmentDate(foundOptionQuote);
  };
  const formatDatesForDayPicker = () => {
    return availableDates;
  };

  const modifiers = {
    selected: selected,
    preselected: formatDatesForDayPicker().map((date) => new Date(date)),
  };

  const generateHourButtons = (hours, page) => {
    const hoursPerPage = hours.slice(
      page * itemsPerPageHours,
      (page + 1) * itemsPerPageHours
    );
    return hoursPerPage.map((hour, index) => (
      <button
        className="o-appointment__buttonHour"
        key={index}
        onClick={() => hourselect(hour)}
      >
        {hour}
      </button>
    ));
  };

  const handleDayClick = (day) => {
    setHoursSelected([]);
    const fechaBusquedaFormateada = new Date(
      day - 24 * 60 * 60 * 1000
    ).toDateString();
    const availability = dateTimeAvailability?.find(
      (item) => new Date(item.date).toDateString() === fechaBusquedaFormateada
    );

    setDayAvailableSelected(availability);
    const hoursDate =
      availability?.availability?.options?.map((option) => option.time) || [];
    setHours(hoursDate);
    setCurrentpagehours(0);
    setSelected(day);
  };

  const handleOpenConfirmedAppointment = () => {
    setShowConfirmedAppointment(true);
  };

  const resetCalendarValues = () => {
    setHoursSelected([]);
    setSelectedCard(undefined);
    setSelected(undefined);
    setAvailableDates([]);
    setNameProfessional([]);
  };

  const token = globalContext.userInfoContext.data?.userJwt;
  const mode = window?.location?.pathname?.includes("nutricionistas")
    ? "CI"
    : "PN";

  const resetForm = () => {
    if (mode !== "PN") dispatchDurations({type: "SET_VALUE", payload: ""});
    dispatchPlaces({type: "SET_VALUE", payload: ""});
    resetCalendarValues();
  };

  useEffect(() => {
    // get durations
    if (!token) return;
    (async () => {
      try {
        dispatchDurations({ type: "LOADING" });
        const response = await getDurations(token, mode);
        const options = response.data.data.map((item) => ({
          id: item.serviceIdCoco,
          maskName: item.name,
          price: item.price,
          url: item.urlRedirect,
        }));
        const process = {
          type: "SET_OPTIONS",
          payload: options,
        };
        dispatchDurations(process);

        if (mode === "PN") {
          dispatchDurations({ type: "SET_VALUE", payload: options[0].id });
          setInformationService({
            price: options[0].price,
            url: options[0].url,
          });
        }
      } catch (error) {
        alert("Ups, hubo un error al cargar las duraciones");
        dispatchDurations({ type: "ERROR" });
      }
    })();
  }, [token]);

  useEffect(() => {
    resetCalendarValues();
    if (!durations.value) return;
    // get places
    (async () => {
      try {
        dispatchPlaces({type: "LOADING"});
        const response = await getPlaces(durations.value, token);
        const process = {
          type: "SET_OPTIONS",
          payload: response.data.data.places,
        };
        dispatchPlaces(process);
      } catch (error) {
        alert("Ups, hubo un error al cargar las sedes");
        dispatchPlaces({ type: "ERROR" });
      }
    })();
  }, [durations.value]);

  useEffect(() => {
    // get professionals
    if(!places.value) return;
    setLoadingProfessionals(true);
    getProfessionalsList(durations.value, places.value);
  }, [places.value]);

  if (!token) return <PelaseLogin />;

  if (durations.error || places.error) return <Error />;

  return (
    <>
      {showConfirmedAppointment ? (
        <ConfirmedAppointment
          appointmenData={appointmentDate}
          globalContext={globalContext}
          informationService={informationService}
          psychologicalContent={props.confirmationForm}
        />
      ) : (
        <div className="o-appointment">
          <div className="o-appointment__container">
            {mode !== "PN" &&
              (durations.loading ? (
                <Loading />
              ) : durations.options?.length > 0 ? (
                <DropdownComponent
                  title="Elegir duración"
                  isDropdownOpen={isDropdownDurationOpen}
                  disabledCondition={true}
                  handleDropdownToggle={handleDropdownDurationToggle}
                  chosenOption={durations.value}
                  optionsList={durations.options}
                  secondTitle="Duración"
                  handleOptionSelect={handleSelectDuration}
                />
              ) : (
                "No hay duraciones disponibles"
              ))}
            {places.loading ? (
              <Loading />
            ) : places.options?.length > 0 || !durations.value ? (
              <DropdownComponent
                title="Elegir sede"
                isDropdownOpen={isDropdownOpen}
                disabledCondition={!!durations.value}
                handleDropdownToggle={handleDropdownToggle}
                chosenOption={places.value}
                optionsList={places.options}
                secondTitle="Seleccionar sede"
                handleOptionSelect={handleSelectPlace}
              />
            ) : (
              "No hay espacios disponibles"
            )}
          </div>

          {/* TODO: end of it */}
          <div className="o-appointment__container">
            <section className="o-appointment__section">
              <span className="o-appointment__title">Profesionales</span>
              <p className="o-appointment__description">
                Elige un especialista para conocer las fechas disponibles para
                agendar tu cita.
              </p>
              {/* TODO: the next line was changed  */}
              {loadingProfessionals ? (
                <Loading />
              ) : (
                places.value && (
                  <div className="o-appointment__cards">
                    <Slider {...settings}>
                      {professionals?.map((card) => {
                        return (
                          <div
                            className={`o-appointment__card ${
                              selectedCard === card.id ? "selected" : ""
                            }`}
                            onClick={() => {
                              chooseprofessional(card.id, card.name);
                            }}
                          >
                            <div className="o-appointment__top-section">
                              <img
                                src={card.sex === "M" ? iconFemale : iconMale}
                                alt="Icono de usuario"
                              />
                              <div className="o-appointment__content">
                                <div className="o-appointment__name">
                                  <p>{card.name}</p>
                                </div>
                                <div className="o-appointment__profession">
                                  <p>{card.profession}</p>
                                </div>
                                {selectedCard === card.id && hours.length > 0 && (
                                  <div className="o-appointment__pagination">
                                    <button
                                      className="o-appointment__ButtonBefore"
                                      onClick={() =>
                                        setCurrentpagehours(
                                          currentpagehours - 1
                                        )
                                      }
                                      disabled={currentpagehours === 0}
                                    >
                                      &lt;
                                    </button>
                                    <div className="o-appointment__hours">
                                      {generateHourButtons(
                                        hours,
                                        currentpagehours
                                      )}
                                    </div>
                                    <button
                                      className="o-appointment__ButtonAfter"
                                      onClick={() =>
                                        setCurrentpagehours(
                                          currentpagehours + 1
                                        )
                                      }
                                      disabled={
                                        (currentpagehours + 1) *
                                          itemsPerPageHours >=
                                        hours.length
                                      }
                                    >
                                      &gt;
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </Slider>
                  </div>
                )
              )}
            </section>

            <section className="o-appointment__section">
              <span className="o-appointment__title">Agenda</span>
              <p className="o-appointment__description">
                Elige una de las fechas disponibles para conocer las horas en
                las que puedes agendar tu cita.
              </p>
                <div className="o-appointment__daypicker-and-buttons">
                  <div className="o-appointment__daypicker">
                    <DayPicker
                      mode="single"
                      selected={selected}
                      onDayClick={handleDayClick}
                      footer={<Footer />}
                      locale={es}
                      modifiers={modifiers}
                      modifiersClassNames={{
                        selected: "my-selected",
                        preselected: "my-today",
                      }}
                      disabled={!selectedCard}
                      onMonthChange={(month) => {
                        chooseprofessional(
                          selectedCard,
                          nameProfessional,
                          month
                        );
                      }}
                    />
                  </div>
                  <div className="o-appointment__button-and-summary">
                    <div className="o-appointment__button-wrapper">
                      {selected && (
                        <Summary
                          title={
                            props.confirmationForm.descripcion.json?.content[0]
                              .content[0].value
                          }
                          selectSpecialist={nameProfessional}
                          date={format(selected, "PP", {
                            locale: es,
                          })}
                          time={hoursSelected}
                        />
                      )}
                      <div className="o-appointment__buttons">
                        <Button
                          type="button"
                          text="Confirmar cita"
                          classname={`secondary`}
                          isDisabled={
                            hoursSelected.length === 0 ||
                            appointmentDate.length === 0
                          }
                          onClickAction={handleOpenConfirmedAppointment}
                        />
                        <Button
                          type="button"
                          text="Reiniciar cita"
                          classname={`primary`}
                          onClickAction={resetForm}
                          isDisabled={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
            </section>
          </div>
        </div>
      )}
    </>
  );
});
export default Appointment;
